import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Flame, Leaf, Sprout, Droplet } from 'lucide-react';
const ingredients = [{
  icon: Flame,
  title: 'Ginger + Black Pepper',
  desc: 'Create deep, natural warmth that stimulates blood flow'
}, {
  icon: Leaf,
  title: 'Eucalyptus',
  desc: 'Helps calm pain signals without dulling sensation'
}, {
  icon: Sprout,
  title: 'Rosemary',
  desc: 'Supports circulation and tissue recovery'
}, {
  icon: Droplet,
  title: 'Botanical Oils',
  desc: 'Absorb quickly, clean, no residue'
}];
export function MechanismSection() {
  return <section className="py-8 sm:py-12 bg-white" data-id="element-1112">
      <div className="max-w-6xl mx-auto px-4" data-id="element-1113">
        <div className="text-center mb-8 sm:mb-10 max-w-3xl mx-auto" data-id="element-1114">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-charcoal mb-3 tracking-tight" data-id="element-1115">
            How It Works (What Actually Matters)
          </h2>
          <p className="text-sm sm:text-base text-charcoal-light font-light" data-id="element-1116">
            Most products stay on the surface.{' '}
            <span className="text-ginger font-normal" data-id="element-1117">
              GINEXT works beneath it.
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-1118">
          {ingredients.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="bg-bone p-5 sm:p-6 rounded-xl border border-bone-dark hover:border-ginger/30 transition-colors group" data-id="element-1119">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm group-hover:shadow-warm transition-all" data-id="element-1120">
                <item.icon className="w-5 h-5 text-ginger" data-id="element-1121" />
              </div>
              <h3 className="text-base font-normal text-charcoal mb-2" data-id="element-1122">
                {item.title}
              </h3>
              <p className="text-charcoal-light text-xs leading-relaxed font-light" data-id="element-1123">
                {item.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="mt-8 sm:mt-10 text-center" data-id="element-1124">
          <p className="text-lg sm:text-xl font-light italic text-charcoal" data-id="element-1125">
            The result? Warmth spreads. Tension eases. Movement returns.
          </p>
        </motion.div>

        {/* Botanical Image - Mobile Only */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="mt-8 md:hidden" data-id="element-1126">
          <img src="https://cdn.magicpatterns.com/uploads/97sqaUrdBqUciwRvsyNBPa/u8896349413_High-end_editorial_still_life_of_natural_botanica_49b5ba3a-5db6-456d-b96b-050e1d7f556a_0_(1).png" alt="Natural botanical ingredients" className="w-full h-auto rounded-xl shadow-lg" loading="lazy" decoding="async" width="800" height="600" data-id="element-1127" />
        </motion.div>
      </div>
    </section>;
}